"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "slideAtom", {
    enumerable: true,
    get: function() {
        return slideAtom;
    }
});
const _reactmotion = require("@fluentui/react-motion");
const slideAtom = ({ direction, duration, easing = _reactmotion.motionTokens.curveLinear, delay = 0, fromX = '0px', fromY = '20px' })=>{
    const keyframes = [
        {
            translate: `${fromX} ${fromY}`
        },
        {
            translate: '0px 0px'
        }
    ];
    if (direction === 'exit') {
        keyframes.reverse();
    }
    return {
        keyframes,
        duration,
        easing,
        delay
    };
};
